import Link from 'next/link';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 12px;
`;

export const Title = styled.p`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;

export const StyledLink = styled(Link)`
  &&& {
    height: 20px;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: ${COLORS.link};
    padding: 0;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
